import React, {useContext, useReducer} from "react";
import {initialState, reducer} from "./reducer";

const AuthStateContext = React.createContext(null)
const AuthDispatcherContext = React.createContext(null)

export function useAuthState() {
    const context = useContext(AuthStateContext)

    if (!context)
        throw Error('useAuthState must be use with a AuthProvider')

    return context
}

export function useAuthDispatcher() {
    const context = useContext(AuthDispatcherContext)

    if (!context)
        throw Error('useAuthDispatcher must be use with a AuthProvider')

    return context
}


export function AuthProvider({children}) {

    function init(initialState) {
        return initialState
    }

    let [state, dispatch] = useReducer(reducer, initialState, init)

    return (
        <AuthStateContext.Provider value={state}>
            <AuthDispatcherContext.Provider value={dispatch}>
                {children}
            </AuthDispatcherContext.Provider>
        </AuthStateContext.Provider>
    )
}